export default __webpack_public_path__ + "static/media/google-sheets-toolbox.cb8879bf.svg";